export const sources = {
  ballot: {
    id: "ma-sec-state-primary-2026",
    name: "Massachusetts Secretary of the Commonwealth",
    url: "https://www.sec.state.ma.us/divisions/elections/research-and-statistics/candidates2026.htm",
    kind: "official-candidate-list",
    checkedAt: "2026-08-24",
  },
  democraticCandidates: {
    id: "ma-sec-dem-primary-candidates-2026",
    name: "Massachusetts Secretary of the Commonwealth",
    url: "https://www.sec.state.ma.us/divisions/elections/research-and-statistics/dem-state-primary-candidates2026.htm",
    kind: "official-candidate-list",
    checkedAt: "2026-08-24",
  },
  republicanCandidates: {
    id: "ma-sec-rep-primary-candidates-2026",
    name: "Massachusetts Secretary of the Commonwealth",
    url: "https://www.sec.state.ma.us/divisions/elections/research-and-statistics/rep-state-primary-candidates2026.htm",
    kind: "official-candidate-list",
    checkedAt: "2026-08-24",
  },
  calendar: {
    id: "ma-sec-upcoming-elections-2026",
    name: "Massachusetts Elections Division",
    url: "https://www.sec.state.ma.us/divisions/elections/recent-updates/upcoming-elections.htm",
    kind: "official-election-calendar",
    checkedAt: "2026-08-24",
  },
  geography: {
    id: "census-cartographic-boundaries",
    name: "U.S. Census Bureau cartographic boundaries",
    url: "https://www.census.gov/geographies/mapping-files/time-series/geo/cartographic-boundary.html",
    kind: "official-geography",
    checkedAt: "2026-08-24",
  },
};

export const election = {
  id: "ma-primary-2026-09-01",
  name: "Massachusetts State Primary",
  date: "2026-09-01",
  registrationDeadline: "2026-08-22",
  mailDeadline: "2026-08-25T17:00:00-04:00",
  earlyVoting: "August 22–28",
  pollingHours: "7:00 AM–8:00 PM",
  jurisdiction: "Massachusetts",
  sourceIds: [
    sources.calendar.id,
    sources.ballot.id,
    sources.democraticCandidates.id,
    sources.republicanCandidates.id,
  ],
};

export const candidates = [
  {
    id: "edward-markey",
    name: "Edward J. Markey",
    initials: "EM",
    party: "democratic",
    role: "United States Senator",
    locality: "Malden",
    office: "U.S. Senate",
    recordCoverage: "Federal legislative record available",
    summary: "Incumbent U.S. senator seeking the Democratic nomination. Legislative, sponsorship, vote, and federal campaign-finance imports are supported by the Civics pipeline.",
    evidence: { ballot: "verified", record: "available", finance: "queued", positions: "researching" },
  },
  {
    id: "seth-moulton",
    name: "Seth Moulton",
    initials: "SM",
    party: "democratic",
    role: "Member of Congress; veteran",
    locality: "Salem",
    office: "U.S. Senate",
    recordCoverage: "Federal legislative record available",
    summary: "Current member of Congress and veteran seeking the Democratic nomination. His congressional actions can be compared with campaign statements as evidence is imported.",
    evidence: { ballot: "verified", record: "available", finance: "queued", positions: "researching" },
  },
  {
    id: "john-deaton",
    name: "John Deaton",
    initials: "JD",
    party: "republican",
    role: "Veteran",
    locality: "Bolton",
    office: "U.S. Senate",
    recordCoverage: "Federal campaign-finance record available",
    summary: "Republican candidate for U.S. Senate. The official ballot lists his occupation as veteran; campaign claims and finance records remain separate evidence layers.",
    evidence: { ballot: "verified", record: "not-applicable", finance: "queued", positions: "researching" },
  },
  {
    id: "maura-healey",
    name: "Maura Healey",
    initials: "MH",
    party: "democratic",
    role: "Governor; former Attorney General",
    locality: "Arlington",
    office: "Governor",
    recordCoverage: "Executive record enrichment queued",
    summary: "Incumbent governor seeking the Democratic nomination. Executive actions, budgets, signed legislation, and official policy statements form the relevant record layer.",
    evidence: { ballot: "verified", record: "queued", finance: "queued", positions: "researching" },
  },
  {
    id: "michael-minogue",
    name: "Michael Roger Minogue",
    initials: "MM",
    party: "republican",
    role: "Veteran",
    locality: "Hamilton",
    office: "Governor",
    recordCoverage: "Public-record scan queued",
    summary: "Republican gubernatorial candidate. The official ballot verifies his candidacy and lists his occupation as veteran; further evidence is not yet synthesized.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "brian-shortsleeve",
    name: "Brian Shortsleeve",
    initials: "BS",
    party: "republican",
    role: "Veteran",
    locality: "Barnstable",
    office: "Governor",
    recordCoverage: "Public-record scan queued",
    summary: "Republican gubernatorial candidate. Civics currently preserves the official ballot identity while the public-record and policy layers are assembled.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "kimberley-driscoll",
    name: "Kimberley Driscoll",
    initials: "KD",
    party: "democratic",
    role: "Lieutenant Governor; former Mayor of Salem",
    locality: "Salem",
    office: "Lieutenant Governor",
    recordCoverage: "Executive and municipal record queued",
    summary: "Incumbent lieutenant governor seeking the Democratic nomination, with an executive and municipal record ready for source enrichment.",
    evidence: { ballot: "verified", record: "queued", finance: "queued", positions: "researching" },
  },
  {
    id: "shawn-oliver",
    name: "Shawn Oliver",
    initials: "SO",
    party: "republican",
    role: "New Bedford City Councillor",
    locality: "New Bedford",
    office: "Lieutenant Governor",
    recordCoverage: "Municipal record scan queued",
    summary: "Republican candidate and current New Bedford city councillor. Municipal actions and campaign statements have not yet been synthesized.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "andrea-campbell",
    name: "Andrea Joy Campbell",
    initials: "AC",
    party: "democratic",
    role: "Attorney General",
    locality: "Dartmouth",
    office: "Attorney General",
    recordCoverage: "Executive record enrichment queued",
    summary: "Incumbent attorney general seeking the Democratic nomination. Official actions and litigation positions are distinct from campaign statements in the data model.",
    evidence: { ballot: "verified", record: "queued", finance: "queued", positions: "researching" },
  },
  {
    id: "michael-walsh",
    name: "Michael C. Walsh",
    initials: "MW",
    party: "republican",
    role: "Candidate",
    locality: "Lynnfield",
    office: "Attorney General",
    recordCoverage: "Public-record scan queued",
    summary: "Republican candidate for attorney general. The official ballot verifies his candidacy; additional characterization is intentionally withheld until sourced.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "william-galvin",
    name: "William Francis Galvin",
    initials: "WG",
    party: "democratic",
    role: "Secretary of the Commonwealth",
    locality: "Boston",
    office: "Secretary of State",
    recordCoverage: "Executive record enrichment queued",
    summary: "Incumbent secretary seeking the Democratic nomination. The current Republican candidate roster lists no nomination for this office.",
    evidence: { ballot: "verified", record: "queued", finance: "queued", positions: "researching" },
  },
  {
    id: "deborah-goldberg",
    name: "Deborah B. Goldberg",
    initials: "DG",
    party: "democratic",
    role: "Treasurer and Receiver General",
    locality: "Brookline",
    office: "Treasurer",
    recordCoverage: "Executive record enrichment queued",
    summary: "Incumbent treasurer seeking the Democratic nomination. The office’s financial administration record will be modeled separately from campaign claims.",
    evidence: { ballot: "verified", record: "queued", finance: "queued", positions: "researching" },
  },
  {
    id: "elizabeth-dionne",
    name: "Elizabeth Dionne",
    initials: "ED",
    party: "republican",
    role: "Former Belmont Select Board Member",
    locality: "Belmont",
    office: "Treasurer",
    recordCoverage: "Municipal record scan queued",
    summary: "Republican candidate for treasurer and former Belmont Select Board member. Evidence enrichment is in progress.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "diana-dizoglio",
    name: "Diana DiZoglio",
    initials: "DD",
    party: "democratic",
    role: "State Auditor",
    locality: "Methuen",
    office: "Auditor",
    recordCoverage: "Executive record enrichment queued",
    summary: "Incumbent state auditor seeking the Democratic nomination. The current Republican candidate roster lists no nomination for this office.",
    evidence: { ballot: "verified", record: "queued", finance: "queued", positions: "researching" },
  },
  {
    id: "bethany-andres-beck",
    name: "Bethany Andres-Beck",
    initials: "BA",
    party: "democratic",
    role: "Candidate",
    locality: "6th Congressional District",
    office: "U.S. House · District 6",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Democratic candidate for the 6th Congressional District, which includes Wilmington. Policy and finance evidence remain unsynthesized.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "john-beccia",
    name: "John A. Beccia, III",
    initials: "JB",
    party: "democratic",
    role: "Candidate",
    locality: "6th Congressional District",
    office: "U.S. House · District 6",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Democratic candidate for the 6th Congressional District. Evidence enrichment is in progress.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "jamie-belsito",
    name: "Jamie Belsito",
    initials: "JB",
    party: "democratic",
    role: "Candidate",
    locality: "6th Congressional District",
    office: "U.S. House · District 6",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Democratic candidate for the 6th Congressional District. Prior public service and current campaign claims have not yet been synthesized.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "dan-koh",
    name: "Dan Koh",
    initials: "DK",
    party: "democratic",
    role: "Candidate",
    locality: "6th Congressional District",
    office: "U.S. House · District 6",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Democratic candidate for the 6th Congressional District. Campaign claims, public service, and finance remain distinct evidence layers.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "mariah-lancaster",
    name: "Mariah L. Lancaster",
    initials: "ML",
    party: "democratic",
    role: "Candidate",
    locality: "6th Congressional District",
    office: "U.S. House · District 6",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Democratic candidate for the 6th Congressional District. No ideological characterization is published until source evidence is reviewed.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "tram-nguyen",
    name: "Tram T. Nguyen",
    initials: "TN",
    party: "democratic",
    role: "Candidate",
    locality: "6th Congressional District",
    office: "U.S. House · District 6",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Democratic candidate for the 6th Congressional District. Observable legislative actions will be imported before any higher-level synthesis.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "micah-quinney-jones",
    name: "Micah Quinney Jones",
    initials: "MQ",
    party: "republican",
    role: "Candidate",
    locality: "6th Congressional District",
    office: "U.S. House · District 6",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Republican candidate for the 6th Congressional District. Characterization awaits cited evidence.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "eunice-zeigler",
    name: "Eunice Delice Zeigler",
    initials: "EZ",
    party: "democratic",
    role: "Candidate",
    locality: "Governor's Council · District 5",
    office: "Governor's Council · District 5",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Democratic candidate for the Fifth Governor's Council district, which includes Wilmington. No Republican nomination is currently listed.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "barry-finegold",
    name: "Barry R. Finegold",
    initials: "BF",
    party: "democratic",
    role: "Candidate",
    locality: "Second Essex & Middlesex",
    office: "State Senate · Second Essex & Middlesex",
    recordCoverage: "Legislative record import queued",
    summary: "Listed Democratic candidate in Wilmington's state Senate district. Bills, sponsorships, and roll-call evidence have not yet been synthesized.",
    evidence: { ballot: "verified", record: "queued", finance: "queued", positions: "researching" },
  },
  {
    id: "theodore-semesnyei",
    name: "Theodore T. Semesnyei",
    initials: "TS",
    party: "republican",
    role: "Candidate",
    locality: "Second Essex & Middlesex",
    office: "State Senate · Second Essex & Middlesex",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Republican candidate in Wilmington's state Senate district. Evidence enrichment is queued.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "david-robertson",
    name: "David Allen Robertson",
    initials: "DR",
    party: "democratic",
    role: "Candidate",
    locality: "Nineteenth Middlesex",
    office: "State House · Nineteenth Middlesex",
    recordCoverage: "Legislative record import queued",
    summary: "Listed Democratic candidate in Wilmington's state House district. No Republican nomination is currently listed.",
    evidence: { ballot: "verified", record: "queued", finance: "queued", positions: "researching" },
  },
  {
    id: "marian-ryan",
    name: "Marian T. Ryan",
    initials: "MR",
    party: "democratic",
    role: "Candidate",
    locality: "Northern District",
    office: "Northern District Attorney",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Democratic candidate for Northern District Attorney. Official actions and campaign statements will remain separate evidence layers.",
    evidence: { ballot: "verified", record: "queued", finance: "queued", positions: "researching" },
  },
  {
    id: "david-solet",
    name: "David Marc Solet",
    initials: "DS",
    party: "democratic",
    role: "Candidate",
    locality: "Northern District",
    office: "Northern District Attorney",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Democratic candidate for Northern District Attorney. Further public-record research is in progress.",
    evidence: { ballot: "verified", record: "researching", finance: "queued", positions: "researching" },
  },
  {
    id: "tara-decristofaro",
    name: "Tara E. DeCristofaro",
    initials: "TD",
    party: "democratic",
    role: "Candidate",
    locality: "Middlesex County",
    office: "Middlesex Register of Probate",
    recordCoverage: "Public-record scan queued",
    summary: "Listed Democratic candidate for Middlesex Register of Probate. No Republican nomination is currently listed.",
    evidence: { ballot: "verified", record: "queued", finance: "queued", positions: "researching" },
  },
];

export const races = [
  { id: "us-senate", office: "U.S. Senate", scope: "statewide", democratic: ["edward-markey", "seth-moulton"], republican: ["john-deaton"] },
  { id: "governor", office: "Governor", scope: "statewide", democratic: ["maura-healey"], republican: ["michael-minogue", "brian-shortsleeve"] },
  { id: "lieutenant-governor", office: "Lieutenant Governor", scope: "statewide", democratic: ["kimberley-driscoll"], republican: ["shawn-oliver"] },
  { id: "attorney-general", office: "Attorney General", scope: "statewide", democratic: ["andrea-campbell"], republican: ["michael-walsh"] },
  { id: "secretary", office: "Secretary of State", scope: "statewide", democratic: ["william-galvin"], republican: [] },
  { id: "treasurer", office: "Treasurer", scope: "statewide", democratic: ["deborah-goldberg"], republican: ["elizabeth-dionne"] },
  { id: "auditor", office: "Auditor", scope: "statewide", democratic: ["diana-dizoglio"], republican: [] },
  { id: "us-house-6", office: "U.S. House · District 6", scope: "Wilmington proof", democratic: ["bethany-andres-beck", "john-beccia", "jamie-belsito", "dan-koh", "mariah-lancaster", "tram-nguyen"], republican: ["micah-quinney-jones"] },
  { id: "governors-council-5", office: "Governor's Council · District 5", scope: "Wilmington proof", democratic: ["eunice-zeigler"], republican: [] },
  { id: "state-senate-second-essex-middlesex", office: "State Senate · Second Essex & Middlesex", scope: "Wilmington proof", democratic: ["barry-finegold"], republican: ["theodore-semesnyei"] },
  { id: "state-house-nineteenth-middlesex", office: "State House · Nineteenth Middlesex", scope: "Wilmington proof", democratic: ["david-robertson"], republican: [] },
  { id: "northern-district-attorney", office: "Northern District Attorney", scope: "Wilmington proof", democratic: ["marian-ryan", "david-solet"], republican: [] },
  { id: "middlesex-register-probate", office: "Middlesex Register of Probate", scope: "Wilmington proof", democratic: ["tara-decristofaro"], republican: [] },
];

export const countyNames = {
  "25001": "Barnstable",
  "25003": "Berkshire",
  "25005": "Bristol",
  "25007": "Dukes",
  "25009": "Essex",
  "25011": "Franklin",
  "25013": "Hampden",
  "25015": "Hampshire",
  "25017": "Middlesex",
  "25019": "Nantucket",
  "25021": "Norfolk",
  "25023": "Plymouth",
  "25025": "Suffolk",
  "25027": "Worcester",
};
